import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=5e3fdc5d&scoped=true&"
import script from "./spacer.vue?vue&type=script&lang=js&"
export * from "./spacer.vue?vue&type=script&lang=js&"
import style0 from "./spacer.vue?vue&type=style&index=0&id=5e3fdc5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3fdc5d",
  null
  
)

export default component.exports